// import '@ant-design/compatible/assets/index.css';


import { useQuery } from 'react-query';
import React, { useCallback, useEffect, useState } from 'react';
import Text from 'antd/lib/typography/Text';
import {
  Form,
  Col,
  Spin,
  Row,
  Divider,
  message,
  Input,
  Card,
  InputNumber,
} from 'antd';
import * as finEngine from 'services/finEngine';
import DF from 'DisplayFramework';
import { toCurrency } from 'utils/utils';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import {
  getFinContractViewatEndOfTerm,
  FinConElementViewResponse,
  getFinContractById,
} from 'services/fincontract';

import { FormInstance } from 'antd/lib/form';

import TextArea from 'antd/lib/input/TextArea';

import { PricingResponse } from 'services/pricing';
import { dateToString, shouldUpdateCompare } from 'utils/utils2';
import ThirdPartyInput from 'components/ThirdPartyInput';
import { debounce, isNil, sumBy } from 'lodash';
import InputCurrency from 'components/InputCurrency';
import moment from 'moment';
import GetLabel from 'DisplayFramework/components/GetLabel';
import PricingListFilteredSelect from 'components/PricingListFilteredSelect';

export type TabContractEndOfTermProps = {
  objectid: number;
  object: string;
  form?: FormInstance;
  setSuccessful?: any;
};

const TabContractEndOfTerm = ({
  objectid,
  object,
  form,
  setSuccessful,
}: TabContractEndOfTermProps) => {
  const [state, setState] = useState({
    isLoading: false,
    isModSelected: false,
    newDuration: 0,
    targetdate: '',
    feesamount: 0,
    feesformula: '',
    totalNet: 0,
    totalTax: 0,
    totalGross: 0,
    newElements: [] as FinConElementViewResponse[],
  });

  const [_state, _setState] = useState<any>({
    totalirvamount: 0,
    totalvatrefund: 0,
    totalfinrvamount: 0,
    totalsaleamount: 0,
    totalinvoiceamount: 0,
    currentRental: 0,
    currentOutstanding: 0,
    currentRV: 0,
    newOutstanding: 0,
    newRental: 0,
    newRV: 0,
    totaldegfeesamount: 0,
    totaltpofamount: 0,
    totalspamount: 0,
    taxcode: 'NORM',
    taxrate: 20,
    currcode: localStorage.getItem('currcode') ?? '',
    listAssets: [],
    feesamount: 0,
  });

  const [spamount, setSpamount] = useState(0);

  const { data: contract, isLoading } = useQuery(
    ['getFinContractViewatEndOfTerm', { ctrid: objectid }],
    () =>
      getFinContractViewatEndOfTerm({ ctrid: objectid }).then((res) => {
        form?.setFieldsValue({
          tpidbyuer: {
            tpid: res.data?.tpidclient,
            tpname: res.data?.clientname,
            tpreference: res.data?.clientreference,
          },
          taxcode: 0,
        });

        return res.data;
      }),
    { refetchOnMount: true }
  );

  const {
    data: contractres,
    refetch,
    isLoading: contactLoading,
  } = useQuery(
    ['getFinContractById', { ctrid: objectid }],
    async () => {
      try {
        const res = await getFinContractById({ ctrid: objectid });
        if (_state.listAssets?.length === 0)
          updateState({
            listAssets: res?.data?.assets.filter(
              (a) => a.assetstatus === 'ACTIVE'
            ),
          });
        return res.data;
      } catch (err) {}
    },
    { staleTime: Infinity }
  );

  useEffect(() => {
    setSuccessful(isLoading);
  }, [isLoading]);

  const [currcode, setCurrcode] = useState('EUR');

  useEffect(() => {
    let finElements = contract?.elements?.filter((e) => e?.ctetype === 'FIN');

    let taxcode = finElements ? finElements[0]?.taxcode : '';
    let taxrate = finElements ? finElements[0]?.taxrate : 0;

    let currcode = finElements ? finElements[0]?.currcode : '';
    let targetdate = finElements ? finElements[0]?.cteenddate : moment();
    // targetdate=moment();//.format('YYYY-MM-DD');
    setCurrcode(currcode ?? 'MAD');
    let totalRV = sumBy(finElements, 'ctervamount');
    let taxRV = (totalRV * taxrate) / 100;

    form?.setFieldsValue({
      totalrv: totalRV,
      taxrate: taxrate ?? 0,
      taxraterv: taxrate ?? 0,
      taxcode: taxcode,
      taxcoderv: taxcode,
      taxrv: taxRV,
      targetdate: targetdate,
      feesamount: 0,
      invoicenetamount: 0,
    });
  }, [contract]);

  const calculateTotal = () => {
    if (form?.getFieldValue('targetphase') === 'STOCKIN') {
      let netamount = form.getFieldValue('feesamount');
      let taxrate = form.getFieldValue('taxrate');

      let taxamount = (netamount * (taxrate ?? 0)) / 100;
      let grossamount = netamount + taxamount;
      form?.setFieldsValue({
        feestax: taxamount,
        invoicenetamount: netamount,
        invoicetaxamount: taxamount,
        invoicegrossamount: grossamount,
      });
    } else {
      form?.setFieldsValue({
        invoicenetamount: form.getFieldValue('totalrv'),
        invoicetaxamount: form.getFieldValue('taxrv'),
        invoicegrossamount:
          form.getFieldValue('totalrv') + form.getFieldValue('taxrv'),
      });
    }
  };

  // eslint-disable-next-line no-unused-vars
  const updateState = useCallback(
    (values) => {
      setState((prev) => ({ ...prev, ...values }));
    },
    [setState]
  );

  const calculateFees = (pricing?: PricingResponse) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: [],
          inDownPayment: 0,
          inFinAmount: contract?.elements[0].ctefinancedamount ?? 0,
          inFollowGP: true,
          inGPDuration: contract?.elements[0].ctegraceperiodduration ?? 0,
          inPstype: pricing?.ctecategory ?? '',
          inRoudingAmount: 2,
          inServcalculationmethod:
            pricing?.serviceResponse.servcalculationmethod ?? '',
          inServfixedamount: pricing?.serviceResponse.servfixedamount ?? 0,
          inServiceduration: pricing?.serviceResponse.servduration ?? '',
          inServpercentage: pricing?.serviceResponse.servpercentage ?? 0,
          inTaxcode: pricing?.taxcode ?? '',
          inTaxrate: pricing?.taxrate ?? 0,
          inDuration: contract?.elements[0].cteduration ?? 0,
          inInvestAmount: contract?.elements[0].cteinvestamount ?? 0,
          inAssetAmount: contract?.assets[0].assetnetamount ?? 0,
          inServperiodicity: pricing?.serviceResponse.servperiodicity ?? '1',
          inServDurationFree: pricing?.serviceResponse.servdurationdefault ?? 1,
          inStartDate: dateToString(form?.getFieldValue('targetdate')),
          inServbasis: pricing?.serviceResponse.servbasis ?? 'FLAT',

          inCalculatedamountbasis:
            pricing?.serviceResponse.calculatedamountbasis ?? 'FINANCING',

          inMarginoncalcultedamount:
            pricing?.serviceResponse.marginoncalulatedamount ?? 0,
          inAdditionalcostaftermargin:
            pricing?.serviceResponse.additionalcostaftermargin ?? 0,

          servStep: pricing?.serviceStepList ?? [],
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Service - ' + res.message);

          form?.setFieldsValue({
            feesamount: res.installmentamount,
            feestax: (res.installmentamount * (pricing?.taxrate ?? 0)) / 100,
            feestaxcode: pricing?.taxcode,
            feestaxrate: pricing?.taxrate,
            feestype: pricing?.ctetype,
            feescategory: pricing?.ctecategory,
          });

          calculateTotal();
        }
      });
  };

  const debounceSpvalueChange = debounce(() => {
    form?.setFieldsValue({
      spamount: 0,
      spformula: null,
    });
    updateState({ totalspamount: 0 });
  }, 1000);

  const calculateSpFees = (pricing?: PricingResponse, ctetype?: string) => {
    if (pricing) {
      // if (pricing.calculationmethod==='OUTINT' || 'OUTRENTAL' || 'TOTXINT') {

      //   // add here the call of the new API : getTPofFees

      //   const feesamount = state.feesamount ?? 0;

      //   if (ctetype === 'TPOF') {
      //     let totalinvoiceamount =
      //       Number(state.totalsaleamount) +
      //       Number(state.totaldegfeesamount) +
      //       Number(res.installmentamount) +
      //       Number(state.totalspamount) +
      //       feesamount;

      //     let totaltpofamount = res.installmentamount;

      //     let listAssets = state.listAssets.map((asset: any) => {
      //       let newtotal = 0;
      //       if (form?.getFieldValue('targetphase') === 'ASSETOUT') {
      //         newtotal = asset.saleamount + res.installmentamount / coef;
      //       } else {
      //         newtotal =
      //           asset.degfeesamount +
      //           asset.spamount +
      //           res.installmentamount / coef;
      //       }

      //       return {
      //         ...asset,
      //         tpofamount: res.installmentamount / coef,
      //         totalinvoiceamount: newtotal,
      //       };
      //     });
      //     updateState({
      //       totalinvoiceamount: totalinvoiceamount,
      //       totaltpofamount: totaltpofamount,
      //       listAssets: listAssets,
      //     });

      //     form?.setFieldsValue({
      //       totalinvoiceamount: totalinvoiceamount,
      //       totaltpofamount: totaltpofamount,
      //       listAssets: listAssets,
      //     });

      // }else {

      let totalamount = sumBy(contractres?.assets, 'assetnetamount');
      let currentOutstanding = sumBy(contractres?.assets, 'assetrvamount');

      finEngine
        .calculateServiceWithStep({
          servReq: {
            finSchedule: [],
            inDownPayment: 0,
            inFinAmount: 0,
            inFollowGP: true,
            inGPDuration: 0,
            inPstype: pricing?.ctecategory ?? '',
            inRoudingAmount: 2,
            inServcalculationmethod:
              pricing?.serviceResponse.servcalculationmethod ?? '',
            inServfixedamount: pricing?.serviceResponse.servfixedamount ?? 0,
            inServiceduration: pricing?.serviceResponse.servduration ?? '',
            inServpercentage: pricing?.serviceResponse.servpercentage ?? 0,
            inTaxcode: pricing?.taxcode ?? '',
            inTaxrate: pricing?.taxrate ?? 0,
            inDuration: 0,
            inInvestAmount: totalamount,
            inAssetAmount: totalamount,
            inServperiodicity: pricing?.serviceResponse.servperiodicity ?? '1',
            inServDurationFree:
              pricing?.serviceResponse.servdurationdefault ?? 1,
            inStartDate: form?.getFieldValue('effectDate'),
            inServbasis: pricing?.serviceResponse.servbasis ?? 'FLAT',

            inCalculatedamountbasis:
              pricing?.serviceResponse.calculatedamountbasis ?? 'FINANCING',

            inMarginoncalcultedamount:
              pricing?.serviceResponse.marginoncalulatedamount ?? 0,
            inAdditionalcostaftermargin:
              pricing?.serviceResponse.additionalcostaftermargin ?? 0,

            servStep: pricing?.serviceStepList ?? [],
          },
        })
        .then((res) => {
          if (res.success) {
            message.success('Service - ' + res.message);

            let coef = contractres?.assets?.length ?? 1;

            // //

            const feesamount = state.feesamount ?? 0;

            let spamount =
              res.installmentamount * form?.getFieldValue('spvalue');


            setSpamount(spamount);
            updateState({
              spamount: spamount,
            });

            form?.setFieldValue('spamount', spamount);
            let totalinvoiceamount =
              Number(_state.totalsaleamount) +
              Number(_state.totaldegfeesamount) +
              Number(_state.totaltpofamount) +
              +feesamount +
              spamount;

            totalinvoiceamount += Number(form?.getFieldValue('feesamout')) ?? 0;

            let listAssets = contractres?.assets.map((asset: any) => {
              const newtotal =
                !isNaN(asset.saleamount) &&
                form?.getFieldValue('targetphase') === 'ASSETOUT'
                  ? asset.saleamount + asset.tpofamount
                  : asset.tpofamount + asset.degfeesamount + spamount / coef;
              return {
                ...asset,
                totalinvoiceamount: newtotal,
                spamount: spamount / coef,
              };
            });

            updateState({
              totalinvoiceamount: totalinvoiceamount,
              totalspamount: spamount,
              listAssets: listAssets,
            });
            form?.setFieldsValue({
              totalinvoiceamount: totalinvoiceamount,
              totalspamount: spamount,
              listAssets: listAssets,
              spamount: spamount,
            });
          }
        });
    }
    // } // end if pricing
  };

  return (
    <DF.Provider pagcode="tabendofterm" entity={object} entityid={objectid}>
      <Form form={form} labelAlign="left" layout="vertical">
        <Spin spinning={state.isLoading || isLoading} delay={500}>
          <Row gutter={20}>
            <Col span={17}>
              <Row>
                <Col span={3}>
                  <GetLabel label="asset" />
                </Col>
                <Col span={12}>
                  <GetLabel label="label" />
                </Col>
                <Col span={4}>
                  <GetLabel label="netamount" />
                </Col>
                <Col span={4}>
                  <GetLabel label="residualValue" />
                </Col>
              </Row>
              {contract?.assets?.map((el, index) => (
                <div key={index}>
                  <Row>
                    <Col span={3}>{el.assetreference}</Col>
                    <Col span={12}>{el.assetlabel}</Col>
                    <Col span={4}>
                      {toCurrency(el.assetnetamount, currcode)}
                    </Col>
                    <Col span={4}>{toCurrency(el.assetrvamount, currcode)}</Col>
                  </Row>
                </div>
              ))}
              <Divider orientation="left"></Divider>
              <Row gutter={10}>
                <FormInput
                  col
                  xs={8}
                  name="targetphase"
                  rules={[{ required: true }]}
                >
                  <ParListSelect
                    parcode="ASSETEND"
                    onChange={() => {
                      calculateTotal();
                      form?.setFieldsValue({ targetstatus: '' });
                    }}
                    offerid={contract?.offerid}
                    prcode={contract?.prcode}
                  />
                </FormInput>
                <Form.Item
                  shouldUpdate={shouldUpdateCompare('targetphase')}
                  noStyle
                >
                  {({ getFieldValue }) => (
                    <FormInput col xs={8} name="targetstatus">
                      <ParListSelect
                        parcode="ASSETSTAT"
                        parvalueparent={getFieldValue('targetphase')}
                        disabled={isNil(getFieldValue('targetphase'))}
                      ></ParListSelect>
                    </FormInput>
                  )}
                </Form.Item>
                <Form.Item
                  shouldUpdate={shouldUpdateCompare('targetphase')}
                  noStyle
                >
                  {({ getFieldValue }) => {
                    const display = getFieldValue('targetphase') === 'STOCKIN';
                    if (display) {
                      return (
                        <FormInput col xs={8} name="damage">
                          <ParListSelect
                            parcode="DAMLEVEL"
                            onChange={() => {
                              form?.setFieldsValue({
                                feesamount: 0,
                                feestax: 0,
                                feesformula: '',
                              });
                            }}
                          />
                        </FormInput>
                      );
                    } else {
                      return null;
                    }
                  }}
                </Form.Item>
              </Row>
              <Row gutter={10}>
                <Form.Item
                  shouldUpdate={shouldUpdateCompare(['targetphase', 'damage'])}
                  noStyle
                >
                  {({ getFieldValue }) => {
                    const display = getFieldValue('targetphase') === 'STOCKIN';
                    if (display) {
                      return (
                        <FormInput
                          col
                          xs={8}
                          name="feesformula"
                          //rules={[{ required: true }]}
                        >
                          <PricingListFilteredSelect
                            //disabled={!getFieldValue('offerid')}
                            allowClear
                            disabled={state.isModSelected}
                            params={{
                              offerid: contract?.offerid ?? 0,
                              ctetype: 'DEGFEES', // Modifictaion fees
                              prcode: contract?.prcode ?? '',
                              entity: '',
                              entityid: 0,
                              tpid: contract?.tpidclient ?? 0,
                              filtersValue:
                                'DAMLEVEL=' + getFieldValue('damage') + ',',
                            }}
                            onChange={(e) => calculateFees(e)}
                          />
                        </FormInput>
                      );
                    } else {
                      return null;
                    }
                  }}
                </Form.Item>

                <Form.Item
                  shouldUpdate={shouldUpdateCompare('targetphase')}
                  noStyle
                >
                  {({ getFieldValue }) => {
                    const display = getFieldValue('targetphase') === 'STOCKIN';
                    if (display) {
                      return (
                        <>
                          <FormInput
                            col
                            xs={8}
                            name="feesamount"
                            //rules={[{ required: true }]}
                          >
                            <InputCurrency
                              currcode={currcode}
                              onChange={calculateTotal}
                            />
                          </FormInput>

                          <FormInput
                            col
                            xs={8}
                            name="feestax"
                            //rules={[{ required: true }]}
                          >
                            <InputCurrency currcode={currcode} disabled />
                          </FormInput>
                        </>
                      );
                    } else {
                      return null;
                    }
                  }}
                </Form.Item>

                <FormInput
                  col
                  xs={8}
                  name="spvalue"
                  labelAlign="left"
                  //rules={[{ required: true }]}
                >
                  <InputNumber
                    onChange={(e) => {
                      debounceSpvalueChange();
                    }}
                    disabled={state.isModSelected}
                  />
                </FormInput>

                <Form.Item
                  shouldUpdate={shouldUpdateCompare(['targetphase', 'damage'])}
                  noStyle
                >
                  {({ getFieldValue }) => {
                    return (
                      <FormInput
                        col
                        xs={9}
                        labelAlign="left"
                        name="spformula"
                        //rules={[{ required: true }]}
                        shouldUpdate
                      >
                        <PricingListFilteredSelect
                          //disabled={!getFieldValue('offerid')}
                          allowClear
                          disabled={state.isModSelected}
                          params={{
                            offerid: contract?.offerid ?? 0,
                            ctetype: 'SPFEES',
                            prcode: contract?.prcode! ?? '',
                            entity: '',
                            entityid: 0,
                            tpid: contract?.tpidclient ?? 0,
                            filtersValue:
                              'NBKMS=' + getFieldValue('spvalue') + ',',
                          }}
                          onChange={(e) => calculateSpFees(e, 'SPFEES')}
                        />
                      </FormInput>
                    );
                  }}
                </Form.Item>
                <FormInput
                  col
                  xs={7}
                  labelAlign="left"
                  name="spamount"
                  //rules={[{ required: true }]}
                >
                  <Text>
                    {toCurrency(spamount, localStorage.getItem('currcode'))}
                  </Text>
                </FormInput>
              </Row>
            </Col>

            <Col span={7}>
              <Form.Item
                shouldUpdate={shouldUpdateCompare('targetphase')}
                noStyle
              >
                {({ getFieldValue }) => (
                  <Card
                    type="inner"
                    style={{ background: '#F6F3F2', marginTop: 25 }}
                  >
                    <Row gutter={[8, 8]}>
                      <FormInput
                        col
                        xs={12}
                        name="totalrv"
                        style={{ fontWeight: 'bold', color: 'red' }}
                      >
                        <InputCurrency
                          currcode={currcode}
                          disabled //={getFieldValue('targetphase') === 'STOCKIN'}
                        />
                      </FormInput>

                      <FormInput
                        col
                        xs={12}
                        name="taxrv"
                        style={{ fontWeight: 'bold', color: 'black' }}
                      >
                        <InputCurrency
                          currcode={currcode}
                          disabled //={getFieldValue('targetphase') === 'STOCKIN'}
                        />
                      </FormInput>
                      <FormInput
                        col
                        xs={24}
                        name="targetdate"
                        rules={[{ required: true }]}
                      >
                        <Input disabled />
                      </FormInput>
                    </Row>
                  </Card>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Divider orientation="left"></Divider>
          <Row gutter={20}>
            <Col span={17}>
              <Form.Item
                shouldUpdate={shouldUpdateCompare('targetphase')}
                noStyle
              >
                {({ getFieldValue }) => (
                  <FormInput col xs={17} name="tpidbyuer">
                    <ThirdPartyInput
                      display={getFieldValue('targetphase') === 'STOCKIN'}
                    />
                  </FormInput>
                )}
              </Form.Item>

              <FormInput
                col
                xs={17}
                name="comment"
                rules={[{ required: true }]}
              >
                <TextArea rows={4} />
              </FormInput>
              <Col>
                <Row>
                  <FormInput col xs={4} name="feestaxcode" hidden>
                    <Input hidden />
                  </FormInput>
                  <FormInput col xs={4} name="feestaxrate" hidden>
                    <Input hidden />
                  </FormInput>
                  <FormInput col xs={4} name="feestype" hidden>
                    <Input hidden />
                  </FormInput>
                  <FormInput col xs={4} name="feescategory" hidden>
                    <Input hidden />
                  </FormInput>
                  <FormInput
                    col
                    xs={10}
                    name="taxcoderv"
                    noStyle
                    style={{ visibility: 'hidden' }}
                  />
                  <FormInput
                    col
                    xs={10}
                    name="taxraterv"
                    noStyle
                    style={{ visibility: 'hidden' }}
                  />
                </Row>
              </Col>
            </Col>
            <Col
              span={7}
              style={{ textAlign: 'right', fontWeight: 'bold', color: 'red' }}
            >
              <Card
                type="inner"
                style={{ background: '#F6F3F2', marginTop: 30 }}
              >
                <Row gutter={20}>
                  <FormInput col xs={12} name="invoicenetamount">
                    <InputCurrency currcode={currcode} disabled />
                  </FormInput>
                  <FormInput col xs={12} name="invoicetaxamount">
                    <InputCurrency currcode={currcode} disabled />
                  </FormInput>
                  <FormInput col xs={24} name="invoicegrossamount">
                    <InputCurrency currcode={currcode} disabled />
                  </FormInput>
                </Row>
              </Card>
            </Col>
          </Row>
        </Spin>
      </Form>
    </DF.Provider>
  );
};
export default TabContractEndOfTerm;
